const TranscriptionStateType = {
    WAITING: Symbol("waiting"),
    RECORDING: Symbol("recording"),
    FINISHED: Symbol("finished"),
};

export default TranscriptionStateType;